// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"571":"settings","925":"notifi","930":"task"}[chunkId] || chunkId) + "." + {"210":"a2db01fa","287":"b110afff","383":"b4a9cddd","571":"8b18f3c5","588":"1b408392","612":"a8a60ffb","776":"b7ed85e3","925":"4473d038","930":"760b4831","979":"c6c94b70","988":"dcf76bd3"}[chunkId] + ".js";
};